import {
  Autocomplete,
  Avatar,
  Box,
  Button,
  FormControl,
  Grid,
  IconButton,
  TextField,
  Typography,
} from "@mui/material";
import { Container } from "@mui/system";
import React, { useEffect, useState } from "react";
import moment from "moment";
import { SummaryAction } from "../../actions/summary";
import List from "@mui/material/List";
import "./Report.css";
// import { Search } from "@mui/icons-material";
import { styled, alpha } from "@mui/material/styles";
import SearchIcon from "@mui/icons-material/Search";
import InputBase from "@mui/material/InputBase";
import Excel from "../../img/excel.png";
import Tooltip from "@mui/material/Tooltip";
import DeleteIcon from "@mui/icons-material/Delete";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import Checkbox from "@mui/material/Checkbox";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const tool = `aaa \n sssss \n sdxsfefc`;

const Search = styled("div")(({ theme }) => ({
  position: "relative",
  borderRadius: theme.shape.borderRadius,
  backgroundColor: "#fff",
  "&:hover": {
    backgroundColor: alpha(theme.palette.common.white, 0.25),
  },
  marginLeft: 0,
  width: "100%",
  [theme.breakpoints.up("sm")]: {
    width: "auto",
  },
}));

const SearchIconWrapper = styled("div")(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: "100%",
  position: "absolute",
  right: "0",
  color: "#2A3478",
  pointerEvents: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: "inherit",
  "& .MuiInputBase-input": {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("md")]: {
      width: "20ch",
    },
  },
}));

const ReportHeader = (props) => {
  const {
    fromDate,
    setFromDate,
    toDate,
    setToDate,
    userList,
    teamList,
    setSingleEmployee,
    singleEmployee,
    showFilteredData,
    switchToOtherPage,
    TeamfilterId,
    setTeamFilterId,
    setuserListId,
    userListId,
    open,
    exportHandler,
    exportHandler1,
    teamfiletdataemp,
    setTeamfiletdataemp,
    TeamListData,
    setTeamListData,
    getmanagerId,
    setStatusId,
    selectOptonCustomer,
    selectOptonSatatus,
    // empWiseGroupExport
    clientListForDropDown,
    selectClients,
    setSelectClients,
  } = props;

  const daysFilter = [
    { userId: 1, title: "This Week" },
    { userId: 2, title: "This Month" },
    { userId: 3, title: "This Quarter" },
    { userId: 4, title: "Today" },
    { userId: 5, title: "Yesterday" },
  ];
  const teamSelect = [
    { userId: 1, title: "REALME" },
    { userId: 2, title: "Sehwag" },
    { userId: 3, title: "Shimla" },
    { userId: 4, title: "MICROMAX" },
    { userId: 5, title: "Team 5" },
  ];

  const SatausFilter = [
    { id: 1, title: "APPROVED" },
    { id: 2, title: "REJECTED" },
    { id: 3, title: "PENDING" },
  ];
  // let filterTeam = [];
  // const getUserId=()=>{
  //   const userid=teamfiletdataemp?.map((val)=>val.hrmsUserId)
  //   setuserListId(userid)
  // }

  // const teamFilterData = () => {
  //   let userArraydata = [];

  //   setTeamfiletdataemp(userList);
  //   const filterTeam = TeamfilterId?.employeeDtoList?.map((user) => {
  //     const userFilterData = userList?.filter((val) => val.hrmsUserId == user.id);
  //     if (userFilterData.length > 0) {
  //       userArraydata.push(userFilterData[0]);
  //     }

  //     setTeamfiletdataemp(userArraydata);
  //   });

  // };

  // const getmanagerId = (e) => {
  //   if (e !== null) {
  //     setTeamFilterId(e);
  //   } else {
  //     setTeamFilterId("");
  //   }

  // };

  // const teamListData = () => {
  //   let arraydata = [];
  //   const filterTeam1 = userList.map((user) => {
  //     const teamdata = teamList.filter(
  //       (val) => val.manager.id == user.hrmsUserId
  //     );
  //     if (teamdata.length > 0) {
  //       arraydata.push(teamdata[0]?.manager);
  //     }

  //     setTeamListData(arraydata);
  //   });

  // };

  // useEffect(() => {
  //   teamFilterData();
  //   teamListData();

  // }, [TeamfilterId, userList]);
  // useEffect(()=>{

  // },[userListId])

  console.log(singleEmployee);
  return (
    <Box sx={{ paddingBottom: "8px" }} maxWidth="true">
      {/* <Typography
        variant="h4"
        gutterBottom
        sx={{
          color: "#2A3478",
          fontSize: "23px",
        }}
      >
        Meeting List
      </Typography> */}
      <Grid container style={{ placeItems: "center" }}>
        <Grid item xs={12}>
          <Box className="top_fields" display={"flex"} gap="5px">
            <div className="field_box field_toggle">
              <div
                className={`${open.Boolean ? "active" : ""}`}
                onClick={() => switchToOtherPage("summary")}
              >
                Combine Meeting Report
              </div>
              <div
                className={`${open.Boolean ? "" : "active"}`}
                onClick={() => switchToOtherPage("empWise")}
              >
                EMP Wise Report
              </div>
            </div>
            <div className="field_box calender">
              <span>From</span>
              <TextField
                name="fromDate"
                type="date"
                size="small"
                variant="outlined"
                //inputProps={{ max: toDate }}
                value={fromDate}
                onChange={(e) => {
                  setFromDate(e.target.value);
                  localStorage.removeItem("ScheduledData");
                }}
              />
            </div>
            <div className="field_box calender">
              <span>To</span>
              <TextField
                name="fromDate"
                type="date"
                size="small"
                variant="outlined"
                //inputProps={{ max: toDate }}
                value={toDate}
                onChange={(e) => {
                  setToDate(e.target.value);
                  localStorage.removeItem("ScheduledData");
                }}
              />
            </div>
            <div className="field_box search_box">
              {/* <Search>
                <SearchIconWrapper>
                  <SearchIcon />
                </SearchIconWrapper>
                <StyledInputBase
                  placeholder="Search…"
                  inputProps={{ "aria-label": "search" }}
                />
              </Search> */}
            </div>
            {/* <div className="field_box">
              <Autocomplete
                size="small"
                id="header"
                className="select_box"
                options={TeamListData || []}
                getOptionLabel={(option) =>
                  `${option.firstName} (${option.employeeCode})`
                }
                disablePortal={true}
                fullWidth
                onChange={(event, newValue) => {
                  getmanagerId(newValue);
                }}
                renderOption={(props, option) => {
                  return (
                    <List {...props} key={option.userId}>
                      {`${option.firstName} (${option.employeeCode})`}
                    </List>
                  );
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    margin="dense"
                    placeholder="Select Team"
                  />
                )}
              />
            </div> */}
            <div className="field_box multi_select">
              <Autocomplete
                size="small"
                id="header"
                multiple
                disableCloseOnSelect
                limitTags={1}
                className="select_box"
                options={teamfiletdataemp || []}
                getOptionLabel={({ name, empCode }) => {
                  return `${name && name} ${empCode && empCode}`;
                }}
                value={singleEmployee || []}
                disablePortal={true}
                fullWidth
                getOptionDisabled={(option) => option.userId === 0}
                onChange={(event, newValue) => {
                  setSingleEmployee(newValue);
                  localStorage.removeItem("ScheduledData");
                }}
                renderOption={(props, option, { selected }) => {
                  return (
                    <List
                      sx={{
                        // opacity: option.userId == 0 ? 0.5 : 1,
                        display:
                          option.userId == 0
                            ? "none !important"
                            : "block !important",
                      }}
                      {...props}
                      key={option.userId}
                    >
                      <Checkbox
                        icon={icon}
                        checkedIcon={checkedIcon}
                        style={{ marginRight: 8 }}
                        checked={selected}
                      />
                      {`${option?.name}(${option?.empCode})`}
                    </List>
                  );
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    margin="dense"
                    placeholder={
                      selectOptonCustomer !== ""
                        ? selectOptonCustomer
                        : // : "Select Client Owner"
                          "Select Employee Name"
                    }
                  />
                )}
              />
            </div>

            {/* <div className="field_box multi_select">
              <Autocomplete
                size="small"
                id="header"
                multiple
                disableCloseOnSelect
                limitTags={1}
                className="select_box"
                options={clientListForDropDown || []}
                getOptionLabel={({ name }) => {
                  return `${name && name}`;
                }}
                value={selectClients || []}
                disablePortal={true}
                fullWidth
                getOptionDisabled={(option) => option.userId === 0}
                onChange={(event, newValue) => {
                  setSelectClients(newValue);
                }}
                isOptionEqualToValue={(option, value) =>
                  option?.id === value?.id
                }
                renderOption={(props, option, { selected }) => {
                  return (
                    <List
                      sx={{
                        display:
                          option.userId == 0
                            ? "none !important"
                            : "block !important",
                      }}
                      {...props}
                      key={option.userId}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          gap: 4,
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <Checkbox
                            icon={icon}
                            checkedIcon={checkedIcon}
                            style={{ marginRight: 8 }}
                            checked={selected}
                          />

                          <Typography sx={{ wordBreak: "break-all" }}>
                            {option?.name}
                          </Typography>
                        </Box>
                         <Typography>{option?.count || 0}</Typography> 
                         //need to comment count when uncommenting the whole autocomplete
                      </Box>
                    </List>
                  );
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    margin="dense"
                    placeholder={
                      selectOptonCustomer !== ""
                        ? selectOptonCustomer
                        : // : "Select Client Owner"
                          "Select Client Name"
                    }
                  />
                )}
              />
            </div> */}

            {/* <div className="field_box">
              <Autocomplete
                size="small"
                id="header"
                className="select_box"
                options={daysFilter || []}
                getOptionLabel={(option) => option.title}
                disablePortal={true}
                fullWidth
                onChange={(event, newValue) => {
                  setSingleEmployee(newValue);
                }}
                renderOption={(props, option) => {
                  return (
                    <List {...props} key={option.userId}>
                      {option.title}
                    </List>
                  );
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    margin="dense"
                    placeholder="This Week"
                  />
                )}
              />
            </div> */}
            <div className="field_box">
              <Autocomplete
                size="small"
                id="header"
                className="select_box"
                options={SatausFilter || []}
                getOptionLabel={(option) => option.title}
                disablePortal={true}
                fullWidth
                onChange={(event, newValue) => {
                  setStatusId(newValue);
                }}
                renderOption={(props, option) => {
                  return (
                    <List {...props} key={option.userId}>
                      {option.title}
                    </List>
                  );
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    margin="dense"
                    placeholder={
                      selectOptonSatatus !== "" ? selectOptonSatatus : "Status"
                    }
                  />
                )}
              />
            </div>

            <div>
              <div>
                {/* {open.Boolean == true ? (
                  <Tooltip
                    title="Export Excel"
                    sx={{ width: "20px" }}
                    onClick={exportHandler}
                  >
                    <img
                      src={Excel}
                      style={{
                        width: "30px",
                        marginTop: "2px",
                        cursor: "pointer",
                      }}
                      alt=""
                    />
                  </Tooltip>
                ) : (
                  <Tooltip
                    title="Export Excel"
                    sx={{ width: "20px" }}
                    onClick={empWiseGroupExport}
                  >
                    <img
                      src={Excel}
                      style={{
                        width: "30px",
                        marginTop: "2px",
                        cursor: "pointer",
                      }}
                      alt=""
                    />
                  </Tooltip>
                )} */}

                {/* {open.Boolean == true && ( */}
                {true && (
                  <Tooltip
                    title={"Export Excel"}
                    sx={{ width: "20px" }}
                    onClick={exportHandler}
                  >
                    <img
                      src={Excel}
                      style={{
                        width: "30px",
                        marginTop: "2px",
                        cursor: "pointer",
                      }}
                      alt=""
                    />
                  </Tooltip>
                )}
              </div>
            </div>
            <div className="field_box btn">
              <div
                id="Reportsbtn"
                onClick={showFilteredData}
                style={{
                  cursor: "pointer",
                }}
              >
                Go
              </div>
            </div>
          </Box>
        </Grid>

        {/* <Grid item xs={2}>
          <Button
            variant="contained"
            onClick={switchToOtherPage}
            style={{ backgroundColor: "#1a274d", float: "right" }}
          >
            {open.text}
          </Button>
        </Grid> */}
      </Grid>
    </Box>
  );
};

export default ReportHeader;
